// src/utils/http.js
import router from '@/router'

async function request(url, options = {}) {
  // 从localStorage获取token
  const token = localStorage.getItem('token');
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      // 如果存在token，则添加到请求头
      ...(token && { token }),
      ...options.headers
    },
    ...options
  }

  const response = await fetch(url, config)

  // 检查是否是401未授权状态
  if (response.status === 401) {
    // 清除本地存储的token
    localStorage.removeItem('token');
    // 跳转到登录页面
    router.push('/login');
    // 抛出错误，以便调用方能捕获
    throw new Error('登录已过期，请重新登录');
  }

  try {
    const result = await response.json()
    
    // 根据新的返回格式处理响应
    if (result.code === 200) {
      return result;
    } else {
      // 当code不为200时，抛出错误，错误信息为msg字段
      throw new Error(result.msg || `Request failed with code: ${result.code}`)
    }
  } catch (e) {
    if (e instanceof SyntaxError) {
      // JSON解析失败的处理
      const text = await response.text()
      throw new Error(`Invalid JSON response: ${text}`)
    }
    // 重新抛出已知的错误（如业务逻辑错误）
    throw e
  }
}

export async function get(url, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  return request(fullUrl, { method: 'GET' })
}

export async function post(url, data = {}, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  return request(fullUrl, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export async function put(url, data = {}) {
  return request(url, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export async function del(url) {
  return request(url, { method: 'DELETE' })
}

// 文件上传函数
export async function upload(file, path = '') {
  const formData = new FormData()
  formData.append('image', file)
  
  if (path) {
    formData.append('path', path)
  }
  
  try {
    const response = await fetch('/api/common/upload', {
      method: 'POST',
      body: formData
    })
    
    const result = await response.json()
    
    if (result.code === 200) {
      return result
    } else {
      throw new Error(result.msg || '上传失败')
    }
  } catch (error) {
    throw new Error('图片上传失败: ' + (error.message || ''))
  }
}

// 导出通用request函数以供特殊需求使用
export { request }